export default function MainPageContentBlock(props){
    return(
        <div id={props.id} className="main-content-block blue-rounded-border">
            {props.content}
        </div>
    )
}